(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2648],{

/***/ 126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/cro/stake",
      function () {
        return __webpack_require__(62423);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ LowCroBalanceDrawer; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+modal@2.2.1_@chakra-ui+system@2.2.12_@types+react@18.0.21_framer-motion@7.4.0_react-dom@18.2.0_react@18.2.0/node_modules/@chakra-ui/modal/dist/index.esm.js + 58 modules
var index_esm = __webpack_require__(96950);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+image@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(18912);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ./src/components/ModalOrDrawer/index.ts
var ModalOrDrawer = __webpack_require__(64881);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/components/TokenIcon.tsx
var TokenIcon = __webpack_require__(47982);
// EXTERNAL MODULE: ./src/components/TransakModal.tsx + 5 modules
var TransakModal = __webpack_require__(41116);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+hooks@2.0.11_react@18.2.0/node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(19267);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/hooks/router.ts + 2 modules
var router = __webpack_require__(81554);
// EXTERNAL MODULE: ./src/hooks/useBalance.ts
var useBalance = __webpack_require__(44752);
// EXTERNAL MODULE: ../packages/wallet/dist/esm/index.js + 44 modules
var esm = __webpack_require__(95142);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
;// CONCATENATED MODULE: ../node_modules/.pnpm/react-use@17.4.0_react-dom@18.2.0_react@18.2.0/node_modules/react-use/esm/useInterval.js

var useInterval = function (callback, delay) {
    var savedCallback = (0,react.useRef)(function () { });
    (0,react.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ var esm_useInterval = (useInterval);

// EXTERNAL MODULE: ../node_modules/.pnpm/react-use@17.4.0_react-dom@18.2.0_react@18.2.0/node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(89951);
// EXTERNAL MODULE: ../node_modules/.pnpm/zustand@4.3.5_react@18.2.0/node_modules/zustand/esm/index.mjs + 1 modules
var zustand_esm = __webpack_require__(32848);
// EXTERNAL MODULE: ../node_modules/.pnpm/zustand@4.3.5_react@18.2.0/node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(54761);
;// CONCATENATED MODULE: ./src/components/LowCroBalanceDrawer/useLowCroBalanceDrawerDisclosure.ts










var MIN_CRO = 10;
var WAIT_MICROSECONDS = 10000;
var SHOW_AGAIN_MICROSECONDS = 30 * 60000;
var useLowCroBalanceDrawer = (0,zustand_esm/* create */.Ue)((0,middleware/* persist */.tJ)(function() {
    return {
        lastShownTime: null
    };
}, {
    name: "useLowCroBalanceDrawer"
}));
var useLowCroBalanceDrawerDisclosure = function() {
    var disclosure = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    var balanceRet = (0,useBalance/* useBalance */.K)();
    var realPathname = (0,router/* useRealPathname */.ZD)();
    var isConnected = esm/* currentWallet.useIsConnected */.AX.useIsConnected();
    var isConnectedToSupportedChain = esm/* currentWallet.useIsConnectedToSupportedChain */.AX.useIsConnectedToSupportedChain();
    var isShownRef = (0,react.useRef)(false);
    var timerRef = (0,react.useRef)();
    var ref = (0,react.useState)(Date.now()), now = ref[0], setNow = ref[1];
    var isLowBalanceRef = (0,react.useRef)(false);
    var lastShownTime = useLowCroBalanceDrawer(function(s) {
        return s.lastShownTime;
    });
    isLowBalanceRef.current = typeof balanceRet.data !== "undefined" && balanceRet.data < MIN_CRO;
    var isInStakeView = realPathname === paths/* pathDict.cro.stake */.o$.cro.stake;
    if (isInStakeView && isConnected && isConnectedToSupportedChain && !isShownRef.current && !timerRef.current && (!lastShownTime || now - lastShownTime >= SHOW_AGAIN_MICROSECONDS) && isLowBalanceRef.current) {
        timerRef.current = setTimeout(function() {
            // if transak modal is open or balance not low, no need to popup
            if (TransakModal/* useTransakModal.getState */.S.getState().isOpen || !isLowBalanceRef.current) {
                timerRef.current = undefined;
                return;
            }
            isShownRef.current = true;
            useLowCroBalanceDrawer.setState({
                lastShownTime: Date.now()
            });
            disclosure.onOpen();
            timerRef.current = undefined;
        }, WAIT_MICROSECONDS);
    }
    esm_useInterval(function() {
        if (!isInStakeView || isShownRef.current || !isLowBalanceRef.current) {
            return;
        }
        setNow(Date.now());
    }, 1000);
    (0,useUnmount/* default */.Z)(function() {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = undefined;
        }
    });
    return disclosure;
};

;// CONCATENATED MODULE: ./src/components/LowCroBalanceDrawer/index.tsx










var LowCroBalanceDrawer = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var ref = useLowCroBalanceDrawerDisclosure(), onClose = ref.onClose, isOpen = ref.isOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, {
            placement: "bottom",
            scrollBehavior: "inside",
            isOpen: isOpen,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                    minH: "60vh",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                            children: t("Low balance")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawerBody */.M1, {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                            src: "/images/google-pay.svg",
                                            alt: "google pay icon",
                                            w: "29px",
                                            h: "16px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                                            h: "11px",
                                            mx: "8px",
                                            orientation: "vertical",
                                            opacity: "1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                            src: "/images/credit-card-pay.svg",
                                            alt: "credit-card pay icon",
                                            w: "21px",
                                            h: "16px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                                            h: "11px",
                                            mx: "8px",
                                            orientation: "vertical",
                                            opacity: "1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                            src: "/images/apple-pay.svg",
                                            alt: "apple pay icon",
                                            w: "32px",
                                            h: "16px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    textStyle: "h3",
                                    mt: "24px",
                                    children: t("No {coinIcon} No problem!", {
                                        coinIcon: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                                                display: "inline-block",
                                                w: "50px",
                                                h: "50px",
                                                token: "cro",
                                                verticalAlign: "middle",
                                                position: "relative",
                                                top: "-4px"
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    mt: "8px",
                                    color: "text-light",
                                    children: t("Buy CRO with Fiat")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawerFooter */.Un, {
                            position: "relative",
                            pt: "45px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredByTransak, {
                                    w: "full",
                                    position: "absolute",
                                    left: "0",
                                    top: "0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    onClick: function() {
                                        onClose();
                                        TransakModal/* useTransakModal.getState */.S.getState().onOpen({
                                            entryPoint: "Popup"
                                        });
                                    },
                                    children: t("Buy {coin}", {
                                        coin: "CRO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var PoweredByTransak = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        boxShadow: "inset 0px 12px 12px -10px rgba(0,0,0,0.12)",
        textAlign: "center",
        bg: "#f4f4f4",
        py: "1px"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
            color: "text-light",
            textStyle: "captionBold",
            opacity: "0.6",
            transform: "scale(0.85)",
            children: [
                "Powered by",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                    display: "inline-block",
                    h: "20px",
                    src: "/images/transak-logo.svg",
                    alt: "transak-logo",
                    verticalAlign: "middle"
                })
            ]
        })
    }));
};


/***/ }),

/***/ 62423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* reexport safe */ _ui_views_StakePage__WEBPACK_IMPORTED_MODULE_0__.h; }
/* harmony export */ });
/* harmony import */ var _ui_views_StakePage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3189);
var __N_SSG = true;



/***/ }),

/***/ 3189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ StakePage_Stake; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ./src/components/Features.tsx
var Features = __webpack_require__(18232);
// EXTERNAL MODULE: ./src/components/LowCroBalanceDrawer/index.tsx + 2 modules
var LowCroBalanceDrawer = __webpack_require__(56260);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ./src/components/SEO/index.ts + 1 modules
var SEO = __webpack_require__(94343);
// EXTERNAL MODULE: ./src/components/useYourTokenDrawer/index.tsx + 2 modules
var useYourTokenDrawer = __webpack_require__(4128);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+tabs@2.1.3_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/tabs/dist/index.esm.js
var dist_index_esm = __webpack_require__(43655);
// EXTERNAL MODULE: ./src/components/HowItWorksDrawer/index.tsx
var HowItWorksDrawer = __webpack_require__(84030);
// EXTERNAL MODULE: ./src/components/MobileAppBarProvider/index.tsx + 4 modules
var MobileAppBarProvider = __webpack_require__(19391);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/hooks/router.ts + 2 modules
var hooks_router = __webpack_require__(81554);
// EXTERNAL MODULE: ./src/hooks/useShowHowItWorks.ts
var useShowHowItWorks = __webpack_require__(45971);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/overrides/next/router.ts
var next_router = __webpack_require__(95849);
// EXTERNAL MODULE: ./src/views/Stake/index.tsx + 3 modules
var Stake = __webpack_require__(10952);
// EXTERNAL MODULE: ./src/views/StakeAndUseLcro/howItWorks.tsx
var howItWorks = __webpack_require__(34961);
;// CONCATENATED MODULE: ./src/views/StakeAndUseLcro/index.tsx













var StakeAndUseLcroView = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var router = (0,next_router/* useRouter */.tv)();
    var realPathname = (0,hooks_router/* useRealPathname */.ZD)();
    var pathInfo = (0,hooks_router/* getPathInfo */.o$)(realPathname);
    var coinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var modes = [
        {
            mode: "stake",
            text: t("Stake {coin}", {
                coin: coinModeInfo.name
            }),
            routePath: coinMode === "cro" ? paths/* pathDict.cro.stake */.o$.cro.stake : paths/* pathDict.atom.stake */.o$.atom.stake
        },
        {
            mode: "use",
            text: t("Use {coin}", {
                coin: coinModeInfo.name
            }),
            routePath: coinMode === "cro" ? paths/* pathDict.cro.useLiquid */.o$.cro.useLiquid : paths/* pathDict.atom.useLiquid */.o$.atom.useLiquid
        }, 
    ];
    (0,MobileAppBarProvider/* useDefaultAppBar */.Xk)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        flexGrow: 1,
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksDrawer/* default */.Z, (0,_object_spread/* default */.Z)({
                hintType: useShowHowItWorks/* HintType.STAKE */.T.STAKE
            }, (0,howItWorks/* useStakeHint */.G)())),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Tabs */.mQ, {
                mb: "2px",
                index: modes.findIndex(function(v) {
                    return v.routePath === realPathname;
                }),
                onChange: function(index) {
                    var mode = modes[index];
                    router.push(mode.routePath);
                },
                role: "heading",
                "aria-label": "Stake",
                "aria-level": 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* TabList */.td, {
                    children: modes.map(function(v) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Tab */.OK, {
                            children: v.text
                        }, v.mode);
                    })
                })
            }),
            pathInfo.category === "stake" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stake/* StakeView */.V, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/views/StakeAndUseLcro/StakeAndUseLcroDesktop.tsx + 1 modules
var StakeAndUseLcroDesktop = __webpack_require__(92699);
// EXTERNAL MODULE: ./src/views/UseLcroDirectly/SupplyLcroModal.tsx + 12 modules
var SupplyLcroModal = __webpack_require__(3344);
;// CONCATENATED MODULE: ./src/views/StakePage/index.tsx










var StakePage_Stake = function() {
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[globalCoinMode];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* SEOTemplate */.M, {
                title: "Stake ".concat(coinModeInfo.name, " and earn validator rewards - Veno Finance"),
                description: "Stake your ".concat(coinModeInfo.name, " with Veno Finance and receive ").concat(coinModeInfo.liquidName, " in return.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InMobile */.FN, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeAndUseLcroView, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeAndUseLcroDesktop/* StakeAndUseLcroDesktop */.L, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* default.lowCroBalanceDrawer */.Z.lowCroBalanceDrawer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LowCroBalanceDrawer/* LowCroBalanceDrawer */.C, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplyLcroModal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(useYourTokenDrawer/* UseYourTokenDrawer */.G, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [913,1790,2463,6371,3344,2100,2391,2699,9774,2888,179], function() { return __webpack_exec__(126); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);